import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountingReportService {

  private URL = environment.api + "api/erp/accounting/report/v2";
  private baseURL = environment.api + "api/erp/accounting/report";

  constructor(
    private http: HttpClient,
  ) { }

  getDailyBook(startDate: number, endDate: number, byMonth: boolean, type: string) {
    return this.http.get(this.URL + '/journal/' + startDate + '/' + endDate + "/" + type, {
      params: {
        byMonth: byMonth
      }
    });
  }

  getLedgerBook(startDate: number, endDate: number, byMonth: boolean, type: string) {
    return this.http.get(this.URL + '/ledger/' + startDate + '/' + endDate + "/" + type, {
      params: {
        byMonth: byMonth
      }
    });
  }

  getPurchasesBook(startDate: number, endDate: number, type: string) {
    return this.http.get(this.URL + '/purchases/' + startDate + '/' + endDate + "/" + type);
  }

  getSalesBook(startDate: number, endDate: number, type: string) {
    return this.http.get(this.URL + '/sales/' + startDate + '/' + endDate + "/" + type);
  }

  getSalesBookByDestination(startDate: number, endDate: number, type: string, destination: number) {
    return this.http.get(this.URL + '/sales-destination/' + startDate + '/' + endDate + "/" + type + '/' + destination);
  }

  getSalesBookByMultiDestination(startDate: number, endDate: number, type: string, destinations: any) {
    return this.http.post(this.URL + '/sales-multi-destination/' + startDate + '/' + endDate + "/" + type, destinations);
  }

  getBalanceBook(date: number, level: any, type: string) {
    return this.http.get(this.URL + '/balance/' + date + '/' + level + "/" + type);
  }

  getStatementReport(startDate: number, endDate: number, type: string, reptype: string) {
    return this.http.get(this.URL + '/statement/' + startDate + '/' + endDate + "/" + reptype + "/" + type);
  }

  getStatementReportByVendor(startDate: number, endDate: number, type: string, vendorId:any, reptype: string) {
    return this.http.get(this.URL + '/statement-vendor/'+ vendorId + '/' + startDate + '/' + endDate + "/" + reptype + "/" + type);
  }


  getBalanceAdminBook(date: number, companyId: any) {
    return this.http.get(this.baseURL + '/admin/balanceadmin/' + date + '/' + companyId);
  }

  getResultsAdminBook(date: number, companyId: any) {
    return this.http.get(this.baseURL + '/admin/resultsadmin/' + date + '/' + companyId);
  }

  getResultsAdministrative(companyId: any, year: any, month: any) {
    return this.http.get(this.baseURL + '/admin/administrative/' + companyId + '/' + year + '/' + month);
  }

  getPartnerIsBlocked(partnerId: any) {
    return this.http.get(this.baseURL + '/admin/isblockedpartner/' + partnerId);
  }

  blockPartner(partnerId: any) {
    return this.http.post(this.baseURL + '/admin/blockpartner/' + partnerId, {});
  }

  unblockPartner(partnerId: any) {
    return this.http.post(this.baseURL + '/admin/unblockpartner/' + partnerId, {});
  }

  blockCompany(companyId: any) {
    return this.http.post(this.baseURL + '/admin/blockusers/' + companyId, {});
  }

  unblockCompany(companyId: any) {
    return this.http.post(this.baseURL + '/admin/unblockusers/' + companyId, {});
  }

  getGeneralBalanceBook(date: number, type: string) {
    return this.http.get(this.URL + '/general/balance/' + date + "/" + type);
  }

  getIncomeBook(startDate: number, endDate: number, type: string) {
    return this.http.get(this.URL + '/income/' + startDate + '/' + endDate + "/" + type);
  }

  getCashflowBook(date: number, type: string) {
    return this.http.get(this.URL + '/cashflow/' + date + "/" + type);
  }

  getNotesBook(date: number, type: string) {
    return this.http.get(this.URL + '/notes/' + date + "/" + type);
  }

  getAccountingBookAll(date: number, type: string) {
    return this.http.get(this.URL + '/all/' + date + "/" + type);
  }

  getBudgetSells(warehouse = null) {
    if (warehouse == null) {
      return this.http.get(this.URL + "/budgetSells")
    } else {
      return this.http.get(this.URL + "/budgetSells", {
        params: {
          warehouseId: warehouse
        }
      })
    }
  }

  getBudgetProvider(warehouse = null) {
    if (warehouse == null) {
      return this.http.get(this.URL + "/budgetProvider")
    } else {
      return this.http.get(this.URL + "/budgetProvider", {
        params: {
          warehouseId: warehouse
        }
      })
    }
  }

  getSaleEstablishment(warehouse: number, start, end) {
    return this.http.get(this.URL + "/saleEstablishment", {
      params: {
        warehouseId: warehouse,
        start: start,
        end: end
      }
    });
  }

  //saleInvoiceDetail
  getSaleInvoiceDetail(warehouse: number, start, end) {
    return this.http.get(this.URL + "/saleInvoiceDetail", {
      params: {
        warehouseId: warehouse,
        start: start,
        end: end
      }
    });
  }

  ///saleDetail/warehouses
  getSaleDetailWarehouses(warehouse: number, start, end) {
    var params;
    if (warehouse) {
      params = {
        warehouseId: warehouse,
        start: start,
        end: end
      };
    } else {
      params = {
        start: start,
        end: end
      }
    }
    return this.http.get(this.URL + "/saleDetail/warehouses", {
      params: params
    });
  }

  getSaleDetailGeneral(start, end) {
    return this.http.get(this.URL + "/saleDetail/general", {
      params: {
        start: start,
        end: end
      }
    });
  }

  getBillPayReceivableAndProviders(startDate: number, endDate: number) {
    return this.http.get(this.URL + `/billpayreceivableprovider/${startDate}/${endDate}`);
  }

  getBillReceivableReport(startDate: number, endDate: number, type: number) {
    return this.http.get(this.URL + `/chronology/${startDate}/${endDate}/${type}`)
  }

  getBillPayChronology(startDate: number, endDate: number, type: number) {
    return this.http.get(this.URL + `/billpaycronology/${startDate}/${endDate}/${type}`)
  }

  companiesActivePartner(idPartner: number) {
    return this.http.get(this.baseURL + `/admin/companiesActivePartner/${idPartner}`)
  }

  displayWarehouseDaysWithoutXmlE(idCompany: number, year: number, month: number){
    return this.http.get(this.baseURL + `/admin/administrative/display/daysxmle/${idCompany}/${year}/${month}`)
  }

  displayWarehouseDaysWithoutXmlR(idCompany: number, year: number, month: number){
    return this.http.get(this.baseURL + `/admin/administrative/display/daysxmlr/${idCompany}/${year}/${month}`)
  }

  displayWarehouseXmlE(idCompany: number, year: number, month: number){
    return this.http.get(this.baseURL + `/admin/administrative/display/xmle/${idCompany}/${year}/${month}`)
  }

  displayWarehouseXmlR(idCompany: number, year: number, month: number){
    return this.http.get(this.baseURL + `/admin/administrative/display/xmlr/${idCompany}/${year}/${month}`)
  }

  displayDaysBankAccountTransfersByCompany(idCompany: number, year: number, month: number){
    return this.http.get(this.baseURL + `/admin/administrative/display/bank/${idCompany}/${year}/${month}`)
  }

  displayBankAccountTransfersByCompany(idCompany: number, year: number, month: number){
    return this.http.get(this.baseURL + `/admin/administrative/display/daysbank/${idCompany}/${year}/${month}`)
  }

  displayUsersByCompany(idCompany: number){
    return this.http.get(this.baseURL + `/admin/administrative/display/users/${idCompany}`)
  }

  getMovesCash(cashId: number, startDate:number, endDate:number) {
    return this.http.get(this.URL + `/cashmoves/${cashId}/${startDate}/${endDate}`);
  }

  getCashClosuresAccountReport(type: string, startDate:number, endDate:number) {
    return this.http.get(this.URL + `/accounts/report/${type}`, {
			params: {
				startDate: startDate,
				endDate: endDate
			}
		});
  }
}
